// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__4vFuw","signatureBlock":"Footer_signatureBlock__1fTCm","signature":"Footer_signature__2L_l2"};